module.exports = __webpack_public_path__ + "img/网站3-74.dc197a77.png";